/**
 * Helper function containing the site's global ad refresh logic.
 * @param {number} postInterval - Base date to add days to.
 * @param {object} googletag - The global namespace the Google Publisher Tag uses for its API.
 * @returns {void} Executes logic with no return.
 */
export default (postInterval, googletag) => {
  // Abstraction for refreshing ads.
  const refreshAds = () => {
    clearTimeout(window.refreshFinished);
    window.refreshFinished = setTimeout(() => {
      googletag.pubads().refresh();
    }, 250);
  };

  // Refresh ads if per post interval meta is set.
  if (postInterval) {
    setInterval(() => refreshAds(), postInterval * 1000);
  }

  // Refresh ads when resizing across breakpoints.
  let previousWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const breakpoints = [768, 1024];
    const newWidth = window.innerWidth;

    const range = [newWidth, previousWidth].sort((a, b) => a - b);

    // Check if the resize crossed a breakpoint. Refresh ads if true.
    if (breakpoints.some((val) => val >= range[0] && val <= range[1])) {
      refreshAds();
    }
    previousWidth = newWidth;
  });
};
